export class jsCode {
  /**
   * this method use for handle div scroll.
   */
  ShowDivScroll(): void {
    // Make sure the DOM is fully loaded before attaching event listeners
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeScrollFunctionality());
    } else {
      this.initializeScrollFunctionality();
    }

    // Add resize event listener
    window.addEventListener('resize', () => this.handleResize());
  }

  private initializeScrollFunctionality(): void {
    // Handle initial setup for div scroll elements
    const divScrollElements = document.querySelectorAll('.divScroll');
    divScrollElements.forEach(divScroll => {
      const answerOptionWrapper = divScroll.querySelector('.answer-option-wrapper') as HTMLElement;
      const questionData = divScroll.querySelector('.question-data') as HTMLElement;
      
      if (answerOptionWrapper && questionData && answerOptionWrapper.offsetWidth > questionData.offsetWidth) {
        const scrollBtn = divScroll.querySelector('.div-scroll-btn') as HTMLElement;
        if (scrollBtn) scrollBtn.style.display = 'block';
      }
    });

    // Attach scroll event listeners to all fieldset wrapper scroll elements
    const scrollElements = document.querySelectorAll('.fieldset-wrapper-scroll');
    scrollElements.forEach(scrollElement => {
      scrollElement.addEventListener('scroll', function() {
        const wrapperElement = this as HTMLElement;
        const answerOptionWrapper = wrapperElement.querySelector('.answer-option-wrapper') as HTMLElement;
        const isRTL = document.querySelectorAll('.RTLDir').length > 0;
        const divScroll = wrapperElement.closest('.divScroll');
        const scrollBtn = divScroll?.querySelector('.div-scroll-btn') as HTMLElement;
        
        if (!answerOptionWrapper || !scrollBtn) return;

        if (isRTL) {
          if (answerOptionWrapper.offsetWidth + wrapperElement.scrollLeft <= wrapperElement.offsetWidth + 5) {
            scrollBtn.style.display = 'none';
          } else if (answerOptionWrapper.offsetWidth + wrapperElement.scrollLeft > wrapperElement.offsetWidth + 5) {
            scrollBtn.style.display = 'block';
          }
        } else {
          const scrollPosition = wrapperElement.scrollLeft;
          const maxScroll = answerOptionWrapper.offsetWidth - wrapperElement.offsetWidth;
          
          // Hide scroll button when we've scrolled to the end (with a small buffer of 5px)
          if (maxScroll - scrollPosition <= 5) {
            scrollBtn.style.display = 'none';
          } else {
            scrollBtn.style.display = 'block';
          }
        }
      });
      
      // Trigger the scroll event once to properly initialize the button visibility
      scrollElement.dispatchEvent(new Event('scroll'));
    });
  }

  private handleResize(): void {
    const divScrollElements = document.querySelectorAll('.divScroll');
    divScrollElements.forEach(divScroll => {
      const answerOptionWrapper = divScroll.querySelector('.answer-option-wrapper') as HTMLElement;
      const scrollBtn = divScroll.querySelector('.div-scroll-btn') as HTMLElement;
      
      if (!answerOptionWrapper || !scrollBtn) return;
      
      if (answerOptionWrapper.offsetWidth > (divScroll as HTMLElement).offsetWidth) {
        scrollBtn.style.display = 'block';
      } else {
        scrollBtn.style.display = 'none';
      }
      
      // Also trigger scroll event on resize to properly update button visibility
      const scrollElement = divScroll.querySelector('.fieldset-wrapper-scroll');
      if (scrollElement) {
        scrollElement.dispatchEvent(new Event('scroll'));
      }
    });
  }
}